import React, { Fragment, useRef, useState } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPeopleArrows } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { PACKAGE_STATUSES } from "../../../../../config/constants";
import { ChangeOwnerModal } from "../../modals/ChangeOwnerModal";

function ChangeOwner(props) {
  const { actionCallback, packageDetails } = props;
  const [showModal, setShowModal] = useState(false);
  const buttonRef = useRef(null);

  if (
    packageDetails.status === PACKAGE_STATUSES.DELETE_IN_PROGRESS
    || !packageDetails.uuid
  ) {
    return null;
  }

  return (
    <Fragment>
      <Link
        to="#"
        className="cursor-pointer mr-2 link-icon-color"
        id={`change-owner-icon-${packageDetails.uuid}`}
        ref={buttonRef}
        onClick={(e) => {
          e.preventDefault();
          setShowModal(true);
        }}
      >
        <FontAwesomeIcon
          size="lg"
          className="mr-2 cursor-pointer"
          pointerEvents="none"
          icon={faPeopleArrows}
        />
      </Link>
      <UncontrolledTooltip
        delay={0}
        target={buttonRef}
        modifiers={{
          preventOverflow: {
            enabled: true,
            boundariesElement: "body",
          },
        }}
      >
        <FormattedMessage id="components.pages.change_owner.action.tooltip" />
      </UncontrolledTooltip>

      {showModal && (
        <ChangeOwnerModal
          item={packageDetails}
          showModal={showModal}
          actionCallback={actionCallback}
          closeModal={() => setShowModal(false)}
        />
      )}
    </Fragment>
  );
}

export { ChangeOwner };
